import { Menu, Dropdown } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Layout } from 'antd';

import './Header.css';

const languages = ['lt', 'en', 'de', 'pl', 'sk'];

export default function Header() {
  // eslint-disable-next-line
  const { _, i18n } = useTranslation();
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    if (language === null) setLanguage(i18n.language);
  }, [language, i18n.language]);

  const handleLanguageSelect = (e) => {
    i18n.changeLanguage(e.key);
    setLanguage(e.key);
  };

  const menu = (
    <Menu onClick={handleLanguageSelect}>
      {languages.map((language) => (
        <Menu.Item key={language}>{language.toUpperCase()}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Layout.Header
      style={{
        alignItems: 'center',
        boxShadow: '0px 2px 50px 4px rgba(51, 65, 85, 0.05)',
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        lineHeight: 'unset',
        padding: 0,
        paddingLeft: 16,
        paddingRight: 16,
        position: 'fixed',
        width: '100%',
        zIndex: 20,
      }}
    >
      <div className='logo'>
        <img src='logo.svg' height={30} alt='Byways logo' />
      </div>
      <Menu theme='light' mode='horizontal' style={{ float: 'right' }}>
        <Dropdown overlay={menu} trigger={['click']}>
          <Row align='middle' justify='space-between' style={{ width: '60px', cursor: 'pointer' }}>
            <i className='ri-global-line' />
            <span>{language ? language.toString().toUpperCase() : 'LLL'}</span>
            <i className='ri-arrow-down-s-line' />
          </Row>
        </Dropdown>
      </Menu>
    </Layout.Header>
  );
}
